// eslint-disable-next-line no-restricted-imports
import { FormControl, FormHelperText, FormLabel } from '@mui/material';
import { useField } from 'formik';
import React from 'react';

interface FormFieldWrapperProps {
  name: string;
  label?: string;
  helperText?: string | React.ReactNode;
  children: React.ReactNode | ((props: any) => React.ReactNode);
}

export const FormFieldWrapper: React.FC<FormFieldWrapperProps> = ({
  name,
  label,
  helperText,
  children,
}) => {
  const [field, meta] = useField(name);
  const showError = Boolean(meta.error && meta.touched);

  return (
    <FormControl fullWidth error={showError}>
      {label && <FormLabel>{label}</FormLabel>}
      {typeof children === 'function'
        ? children({
            field,
            form: { errors: meta.error, touched: meta.touched },
          })
        : children}
      {(helperText || showError) && (
        <FormHelperText sx={{ mx: 0.5 }}>
          {showError ? meta.error : helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};
